/* EQUAL — interacciones (vanilla, sin librerias) */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- reveal on scroll ---------------------------------- */
  function initReveal() {
    var els = document.querySelectorAll('.eq-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('eq-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('eq-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el, i) {
      if (!el.style.getPropertyValue('--eq-d')) {
        var sibs = el.parentElement ? [].indexOf.call(el.parentElement.children, el) : i;
        el.style.setProperty('--eq-d', ((sibs % 6) * 80) + 'ms');
      }
      io.observe(el);
    });
  }

  /* ---- marquee: duplica el contenido para loop continuo -- */
  function initMarquee() {
    document.querySelectorAll('.eq-marquee__track').forEach(function (track) {
      if (track.dataset.cloned) return;
      track.dataset.cloned = '1';
      track.innerHTML = track.innerHTML + track.innerHTML;
    });
  }

  /* ---- back to top -------------------------------------- */
  function initTop() {
    var btn = document.querySelector('.eq-top');
    if (!btn) return;
    var onScroll = function () {
      btn.classList.toggle('eq-show', window.scrollY > window.innerHeight * 0.9);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  /* ---- hero parallax suave ------------------------------ */
  function initHeroParallax() {
    if (reduce) return;
    var marks = document.querySelectorAll('[data-eq-parallax]');
    if (!marks.length) return;
    var tick = function () {
      var y = window.scrollY;
      marks.forEach(function (m) {
        var s = parseFloat(m.dataset.eqParallax) || 0.15;
        m.style.transform = 'translateY(' + (y * s * -1) + 'px)';
      });
    };
    window.addEventListener('scroll', tick, { passive: true });
    tick();
  }

  /* ---- pagina de producto: galeria + variantes --------- */
  function initPDP() {
    var root = document.querySelector('[data-eq-pdp]');
    if (!root) return;

    // galeria
    var main = root.querySelector('.eq-pdp__main img');
    root.querySelectorAll('.eq-pdp__thumbs button').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!main) return;
        main.src = b.dataset.full || b.querySelector('img').src;
        root.querySelectorAll('.eq-pdp__thumbs button').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
      });
    });

    // variantes
    var dataEl = root.querySelector('[data-eq-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-eq-price]');
    var addBtn = root.querySelector('.eq-pdp__add');
    var moneyFmt = dataEl.dataset.money || '${{amount}}';

    function money(cents) {
      var noDec = /no_decimals/.test(moneyFmt);
      var v = (cents / 100).toLocaleString('es-AR', {
        minimumFractionDigits: noDec ? 0 : 2,
        maximumFractionDigits: noDec ? 0 : 2
      });
      if (/\{\{[^}]*\}\}/.test(moneyFmt)) return moneyFmt.replace(/\{\{[^}]*\}\}/, v);
      return '$' + v;
    }
    function currentOptions() {
      return [].map.call(root.querySelectorAll('[data-eq-opt]'), function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }
    function update() {
      var opts = currentOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) {
        var html = money(match.price);
        if (match.compare_at_price && match.compare_at_price > match.price) {
          html = '<s>' + money(match.compare_at_price) + '</s> ' + money(match.price);
        }
        priceEl.innerHTML = html;
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        var span = addBtn.querySelector('span') || addBtn;
        span.textContent = match.available ? (addBtn.dataset.label || 'Agregar') : (addBtn.dataset.sold || 'Sin stock');
      }
      if (idInput) idInput.disabled = !match.available;
    }
    root.querySelectorAll('[data-eq-opt] input').forEach(function (i) {
      i.addEventListener('change', update);
    });
    update();
  }

  /* ---- probador de talles ------------------------------- */
  function initFit() {
    document.querySelectorAll('[data-eq-fit]').forEach(function (root) {
      var dataEl = root.querySelector('[data-eq-fit-data]');
      if (!dataEl) return;
      var D;
      try { D = JSON.parse(dataEl.textContent); } catch (e) { root.hidden = true; return; }

      var norm = function (s) { return String(s).trim().toLowerCase(); };
      var sizeIdx = {};
      D.sizes.forEach(function (s, i) { sizeIdx[norm(s.label)] = i; });

      function parseChart(text) {
        return String(text || '').split(/\r?\n/).map(function (line) {
          var p = line.split(/[;,|\t]/).map(function (x) { return x.trim(); });
          // un guion (-) significa «esta fila no mira ese dato»
          var num = function (v) { return /^[-–—]?$/.test(v || '') ? Infinity : parseFloat(v); };
          return { label: p[0], h: num(p[1]), w: num(p[2]) };
        }).filter(function (r) { return r.label && !isNaN(r.h) && !isNaN(r.w); });
      }
      // de las tablas de un género, usa la que más talles comparte con el producto
      function chartFor(gender) {
        var best = null, bestScore = 0;
        (D.charts[gender] || []).forEach(function (txt) {
          var rows = parseChart(txt);
          var score = rows.filter(function (r) { return sizeIdx.hasOwnProperty(norm(r.label)); }).length;
          if (score > bestScore) { best = rows; bestScore = score; }
        });
        return best;
      }

      var gender = D.hasMujer && !D.hasHombre ? 'mujer' : 'hombre';
      var genderBox = root.querySelector('[data-eq-fit-gender]');
      var genderBtns = genderBox.querySelectorAll('button');
      if (D.hasHombre && D.hasMujer) genderBox.hidden = false;

      // si ninguna tabla sirve para los talles de este producto, no se muestra el probador
      if (!chartFor('hombre') && !chartFor('mujer')) { root.hidden = true; return; }
      if (!chartFor(gender)) gender = gender === 'hombre' ? 'mujer' : 'hombre';

      var h = root.querySelector('[data-eq-fit-h]'), hn = root.querySelector('[data-eq-fit-hnum]');
      var w = root.querySelector('[data-eq-fit-w]'), wn = root.querySelector('[data-eq-fit-wnum]');
      var hOut = root.querySelector('[data-eq-fit-hout]'), wOut = root.querySelector('[data-eq-fit-wout]');
      var res = root.querySelector('[data-eq-fit-result]');
      var sizeEl = root.querySelector('[data-eq-fit-size]');
      var msgEl = root.querySelector('[data-eq-fit-msg]');
      var pick = root.querySelector('[data-eq-fit-pick]');
      var touched = false, chosen = null;

      function metros(cm) { return (cm / 100).toFixed(2).replace('.', ',') + ' m'; }
      function clamp(v, el) {
        var lo = parseFloat(el.min), hi = parseFloat(el.max);
        if (isNaN(v)) return null;
        return Math.min(hi, Math.max(lo, Math.round(v)));
      }
      function nearest(rows, from, ok) {
        var bestI = -1, bestD = 1e9;
        rows.forEach(function (r, i) {
          if (!ok(r, i)) return;
          var d = Math.abs(i - from);
          if (d < bestD || (d === bestD && i > bestI)) { bestD = d; bestI = i; }
        });
        return bestI;
      }

      function compute() {
        var rows = chartFor(gender);
        var hv = parseFloat(h.value), wv = parseFloat(w.value);
        hOut.textContent = metros(hv) + ' · ' + hv + ' cm';
        wOut.textContent = wv + ' kg';
        genderBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.g === gender ? 'true' : 'false'); });
        if (!touched) return;
        res.hidden = false;
        chosen = null; pick.hidden = true;
        if (!rows) { sizeEl.textContent = '—'; msgEl.textContent = 'No tenemos tabla para esta prenda. Escribinos y te ayudamos.'; return; }

        var ih = rows.findIndex(function (r) { return hv <= r.h; });
        var iw = rows.findIndex(function (r) { return wv <= r.w; });
        // si la altura o el peso superan el último talle de la tabla, no inventamos un talle
        if (ih < 0 || iw < 0) {
          sizeEl.textContent = '—';
          msgEl.textContent = 'Tus medidas superan nuestra tabla de talles. Escribinos por Instagram y te ayudamos a elegir.';
          return;
        }
        var idx = Math.max(ih, iw);
        var off = D.offsets[D.fit] || 0;
        idx = Math.min(rows.length - 1, Math.max(0, idx + off));

        var inProduct = function (r) { return sizeIdx.hasOwnProperty(norm(r.label)); };
        var near = nearest(rows, idx, function (r) { return inProduct(r); });
        if (near < 0) { sizeEl.textContent = '—'; msgEl.textContent = 'No pudimos calcular tu talle. Escribinos y te ayudamos.'; return; }
        var rec = rows[near];
        var recSize = D.sizes[sizeIdx[norm(rec.label)]];
        var ideal = rows[idx];

        // la prenda no trae el talle que le corresponde y el más cercano queda lejos: no engañar
        if (!inProduct(ideal) && Math.abs(near - idx) >= 2) {
          var labels = D.sizes.map(function (s) { return s.label; }).join(', ');
          sizeEl.textContent = '—';
          msgEl.textContent = 'Con ' + metros(hv) + ' y ' + wv + ' kg tu talle ideal sería el ' + ideal.label +
            ', pero esta prenda viene en ' + labels + ' y puede no quedarte bien. Escribinos por Instagram y te ayudamos.';
          return;
        }
        sizeEl.textContent = rec.label;

        var msg = 'Con ' + metros(hv) + ' y ' + wv + ' kg te sugerimos el talle ' + rec.label + '. ';
        if (D.notes[D.fit]) msg += D.notes[D.fit] + ' ';
        if (!inProduct(ideal)) {
          msg += 'Tu talle ideal sería el ' + ideal.label + ', que esta prenda no tiene: el más cercano es el ' + rec.label + '.';
        }

        if (recSize.available) {
          chosen = recSize.label;
        } else {
          var alt = nearest(rows, near, function (r) { return inProduct(r) && D.sizes[sizeIdx[norm(r.label)]].available; });
          if (alt >= 0) {
            chosen = D.sizes[sizeIdx[norm(rows[alt].label)]].label;
            msg += ' El talle ' + rec.label + ' está agotado; el más cercano disponible es el ' + chosen + '.';
          } else {
            msg += ' Por ahora no queda stock en ningún talle.';
          }
        }
        msgEl.textContent = msg.replace(/\s+/g, ' ').trim();
        if (chosen) { pick.textContent = 'Elegir talle ' + chosen; pick.hidden = false; }
      }

      function sync(src, dst, el) {
        var v = clamp(parseFloat(src.value), el);
        if (v === null) return;
        dst.value = v;
      }
      [[h, hn], [w, wn]].forEach(function (pair) {
        pair[0].addEventListener('input', function () { touched = true; pair[1].value = pair[0].value; compute(); });
        pair[1].addEventListener('input', function () { touched = true; sync(pair[1], pair[0], pair[0]); compute(); });
        pair[1].addEventListener('change', function () {
          var v = clamp(parseFloat(pair[1].value), pair[0]);
          pair[1].value = v === null ? pair[0].value : v; pair[0].value = pair[1].value; compute();
        });
        // Enter en un campo numérico no debe enviar el formulario de compra
        pair[1].addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); pair[1].blur(); } });
      });
      genderBtns.forEach(function (b) {
        b.addEventListener('click', function () { gender = b.dataset.g; compute(); });
      });
      pick.addEventListener('click', function () {
        if (!chosen) return;
        var group = document.querySelectorAll('[data-eq-opt]')[D.optionPosition - 1];
        if (!group) return;
        var input = [].find.call(group.querySelectorAll('input'), function (i) { return i.value === chosen; });
        if (input) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          pick.textContent = 'Talle ' + chosen + ' elegido ✓';
        }
      });
      compute();
    });
  }

  /* ---- galería de outfits: flechas del carrusel ---------- */
  function initGallery() {
    document.querySelectorAll('[data-eq-gal]').forEach(function (wrap) {
      var scroller = wrap.querySelector('.eq-gal');
      if (!scroller) return;
      wrap.querySelectorAll('[data-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          scroller.scrollBy({ left: parseInt(btn.dataset.dir, 10) * scroller.clientWidth * 0.85, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    });
  }

  function boot() {
    initReveal();
    initMarquee();
    initTop();
    initHeroParallax();
    initPDP();
    initFit();
    initGallery();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
